import { FC, PropsWithChildren } from 'react';
import { useAuthContextProvider } from './hook/useAuthContextProvider';
import { AuthContext } from './AuthContext';

export const AuthContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const state = useAuthContextProvider();

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};
